export function registerGuards(router) {
  // 全局路由守卫
  router.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    next();
  });
}
